/* eslint-disable import/prefer-default-export */
import moment from 'moment';

export const interestPaymentScreens = {
  PAYMENT: 'payment',
  WALLETS: 'wallets',
  ADD_MORE_COLLATERAL: 'add_more_collateral',
  PROCEED_WITH_PAYMENT: 'proceed_with_payment',
};

export const cardHintItems = [
  {
    image: './assets/images/card-step-1.png',
    imageMobile: './assets/images/card-step-mobile-1.png',
    cardStepTitle: 'card_step1_title',
    cardStepUsTitle: 'card_step1_title',
    cardStepSubtitle: '',
  },
  {
    image: './assets/images/card-step-2.png',
    imageMobile: './assets/images/card-step-mobile-2.png',
    cardStepTitle: 'card_step2_title',
    cardStepUsTitle: 'card_step2_title',
    cardStepSubtitle: '',
  },
  {
    image: './assets/images/card-step-3.png',
    imageMobile: './assets/images/card-step-mobile-3.png',
    cardStepTitle: 'card_step3_title',
    cardStepUsTitle: 'card_step3_title',
    cardStepSubtitle: 'card_step3_subtitle',
  },
  {
    image: './assets/images/card-step-4.png',
    imageMobile: './assets/images/card-step-mobile-4.png',
    cardStepTitle: 'card_step4_title',
    cardStepUsTitle: 'card_step4_us_title',
    cardStepSubtitle: '',
  },
  {
    image: './assets/images/card-step-5.png',
    imageMobile: './assets/images/card-step-mobile-5.png',
    cardStepTitle: 'card_step5_title',
    cardStepUsTitle: 'card_step5_title',
    cardStepSubtitle: 'card_step5_subtitle',
  },
];

export const activateCardScreens = {
  ENTER_CVV: 'enter_cvv',
  CONTACT_SUPPORT: 'contact_support',
};

export const cryptodraftScreens = {
  DETAILS: 'details',
  SETTLE: 'settle',
  PAY_PARTIAL: 'pay_partial',
  CALCULATOR: 'calculator',
  REVIEW: 'review',
  WALLETS: 'wallets',
  WITHDRAW: 'withdraw',
  ADD_FUNDS: 'add_funds',
  DETAILS_INFO: 'details_info',
  ADD_MORE_COLLATERAL: 'add_more_collateral',
  PROCEED_WITH_PAYMENT: 'proceed_with_payment',
};

export const infoPopupTypes = {
  CRYTPODRAFT_DETAILS: 'CRYTPODRAFT_DETAILS',
  LOANS_DETAILS: 'LOANS_DETAILS',
  LOANS_PAYOUT_DETAILS: 'LOANS_PAYOUT_DETAILS',
};

export const cardTransactionScreens = {
  DETAILS: 'details',
  CONTACT_SUPPORT: 'contact_support',
  CASHBACK_INFO: 'caskback_info',
};

export const manageCardScreens = {
  MAIN: 'main',
  PIN_SETTINGS: 'pin_settings',
  VIEW_PIN: 'view_pin',
  SET_PIN: 'set_pin',
  STATEMENT_OF_TRANSACTIONS: 'statement_of_transactions',
  CARD_FEES: 'card_fees',
};

export const cardPopups = {
  ACTIVATE: 'activate',
  TRANSACTION_DETAILS: 'transaction_details',
  CVV_PAN: 'cvv_pan',
  CVC: 'cvc',
  PIN: 'pin',
  CARD_TRANSACTION_DETAILS: 'card_transaction_details',
  CARD_GALILEO_BACK_SIDE: 'card_galileo_back_side',
  CARD_TERMS: 'card_terms',
  SHOW_CARD_INFO: 'show_card_info',
  ENABLE_CARD: 'enable_card',
  HINT_CARD: 'hint_card',
  PENDING_CARD_INFO: 'pending_card_info',
  SET_PIN: 'set_pin',
  CARD_CONNECT_FINANCIAL_DETAILS: 'card_connect_financial_details',
};

export const linkWalletsScreens = {
  SELECET_WALLETS: 'select_wallets',
};

export const DEFAULT_FIAT_CURRENCY = 'eur';

export const mainCardTypes = {
  PHYSICAL: 'physical',
  VIRTUAL: 'virtual',
};

export const spendingFlowScreens = {
  CALCULATOR: 'calculator',
  WALLETS: 'wallets',
  REVIEW: 'review',
  TERMS: 'terms',
  ADD_MORE_COLLATERAL: 'add_more_collateral',
  LEDGER: 'ledger',
  PROCEED_WITH_PAYMENT: 'proceed_with_payment',
};

export const cvvAndPanScreens = {
  ACCOUNT_PASSWORD: 'account_password',
};
export const cvvScreens = {
  CVV_CONFIRM_PASSWORD: 'cvv_confirm_password',
  REVEAL_CVV: 'reveal_cvv',
};

export const orderCardFlowScreens = {
  CARD_TYPE: 'card_type',
  CONFIRM_DETAILS: 'confirm_details',
  CONFIRM_VIRTUAL_DETAILS: 'confirm_virtual_details',
  SET_PIN: 'set_pin',
  SELECT_PAYMENT: 'select_payment',
  PROCEED_WITH_PAYMENT: 'proceed_with_payment',
  SELECT_PAYMENT_TYPE: 'select_payment_type',
  CONFORM_PAYMENT_DETAILS: 'confirm_payment_details',
  MULTI_CURRENCY_INFO: 'multi_currency_into',
  LEDGER_DEPOSIT: 'ledger_deposit',
  TRANSACTION_PROCESSED: 'transaction_processed',
  RECEIVE: 'receive',
  FREE_CARD_PROMO: 'free_card_promo',
  DEPOSIT_WALLET_SELECTION: 'deposit_wallet_selection',
  CARD_TERMS: 'card_terms',
  SELECT_CARD_TYPE: 'select_card_type',
};

export const cardProviders = {
  GALILEO: 'galileo',
  MONAVATE: 'monavate',
  CONNECT_FINANCIAL: 'connect_financial',
};

export const isConnectFinancial = (provider) => provider === cardProviders.CONNECT_FINANCIAL;

const cardCapabilities = {
  [cardProviders.GALILEO]: {
    virtualCardPin: false,
    cardPin: true,
    cardSettings: false,
    hidesInactiveCardBalance: false,
    truncatesMerchantLocation: false,
    networkFromStatus: true,
    currencyFromStatus: true,
    pagesTransactionsByDateRange: true,
    usCardArtwork: true,
    statementFormat: 'pdf',
    statementByEmail: true,
    freezeGatedByStatus: false,
    paidCardOrder: true,
  },
  [cardProviders.MONAVATE]: {
    virtualCardPin: true,
    cardPin: true,
    cardSettings: true,
    hidesInactiveCardBalance: true,
    truncatesMerchantLocation: true,
    networkFromStatus: false,
    currencyFromStatus: false,
    pagesTransactionsByDateRange: false,
    usCardArtwork: false,
    statementFormat: 'csv',
    statementByEmail: true,
    freezeGatedByStatus: true,
    paidCardOrder: true,
  },
  [cardProviders.CONNECT_FINANCIAL]: {
    virtualCardPin: false,
    cardPin: false,
    cardSettings: true,
    hidesInactiveCardBalance: false,
    truncatesMerchantLocation: false,
    networkFromStatus: true,
    currencyFromStatus: true,
    pagesTransactionsByDateRange: true,
    usCardArtwork: true,
    statementFormat: 'pdf',
    statementByEmail: false,
    freezeGatedByStatus: true,
    paidCardOrder: false,
  },
};

const unknownProviderCapabilities = {
  virtualCardPin: false,
  cardPin: true,
  cardSettings: true,
  hidesInactiveCardBalance: false,
  truncatesMerchantLocation: false,
  networkFromStatus: false,
  currencyFromStatus: false,
  pagesTransactionsByDateRange: false,
  usCardArtwork: false,
  statementFormat: 'pdf',
  statementByEmail: true,
  freezeGatedByStatus: false,
  paidCardOrder: true,
};

export const getCardCapabilities = (provider) =>
  cardCapabilities[provider] ?? unknownProviderCapabilities;

export const resolveDefaultTransactionStartDate = (cardProvider, today) =>
  isConnectFinancial(cardProvider)
    ? moment(today).subtract(2, 'years').format('YYYY-MM-DD')
    : moment(today).subtract(30, 'd').format('YYYY-MM-DD');

export const CONNECT_FINANCIAL_ORDER_STATUS = {
  FAILED: 1,
  PENDING: 2,
  CONFIRMED: 3,
};

export const CONNECT_FINANCIAL_ORDER_POLL_MS = 10000;

export const resolveConnectFinancialOrderPollInterval = (orderStatus) =>
  orderStatus?.status === CONNECT_FINANCIAL_ORDER_STATUS.PENDING
    ? CONNECT_FINANCIAL_ORDER_POLL_MS
    : false;

export const shouldHideSetPin = (cardProvider, cardStatus) =>
  !getCardCapabilities(cardProvider).cardPin ||
  (cardProvider === cardProviders.MONAVATE && !cardStatus?.isVirtualCard);

export const shouldHideStatementEntry = (cardProvider, isMobileDevice) =>
  isMobileDevice && !getCardCapabilities(cardProvider).statementByEmail;

export const shouldOrderWithoutPayment = (cardProvider, orderFee) =>
  !getCardCapabilities(cardProvider).paidCardOrder || orderFee === 0;

export const resolveInitialOrderScreen = ({
  cardProvider,
  cardType,
  orderableCardTypes,
  isWaitinglist,
  isCardReplacement,
}) => {
  const virtualConfirmation = {
    screen: orderCardFlowScreens.CONFIRM_VIRTUAL_DETAILS,
    options: { onlyVirtualCardAllowed: true },
  };
  if (!getCardCapabilities(cardProvider).paidCardOrder) {
    return virtualConfirmation;
  }
  if (isCardReplacement && cardType !== cardProviders.MONAVATE) {
    return { screen: orderCardFlowScreens.CONFIRM_DETAILS };
  }
  const canOrderVirtual = orderableCardTypes?.includes(mainCardTypes.VIRTUAL.toUpperCase());
  const canOrderPhysical = orderableCardTypes?.includes(mainCardTypes.PHYSICAL.toUpperCase());
  if (canOrderVirtual && canOrderPhysical && !isWaitinglist) {
    return { screen: orderCardFlowScreens.SELECT_CARD_TYPE };
  }
  if (canOrderVirtual && !isWaitinglist) {
    return virtualConfirmation;
  }
  return { screen: orderCardFlowScreens.FREE_CARD_PROMO };
};

export const cardFlipTargets = {
  FLIP: 'flip',
  GALILEO_DETAILS: 'galileo_details',
  CONNECT_FINANCIAL_DETAILS: 'connect_financial_details',
};

export const resolveCardFlipTarget = (cardProvider, isUsUser) => {
  if (isConnectFinancial(cardProvider)) {
    return cardFlipTargets.CONNECT_FINANCIAL_DETAILS;
  }
  return isUsUser ? cardFlipTargets.GALILEO_DETAILS : cardFlipTargets.FLIP;
};

export const FreeCardOrderType = {
  WAIT_LIST: 'waiting_list',
  PROMO_BALANCE: 'promo_balance',
};

export const CardState = {
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
  LOST: 'LOST',
  STOLEN: 'STOLEN',
  DAMAGED: 'DAMAGED',
  DISABLED: 'DISABLED',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING',
  ACTIVATION: 'ACTIVATION',
};

export const resolveOrderLandingCardStatus = (cardProvider, cardStatus, orderStatus) => {
  if (
    isConnectFinancial(cardProvider) &&
    orderStatus?.status === CONNECT_FINANCIAL_ORDER_STATUS.PENDING
  ) {
    return { ...cardStatus, cardState: CardState.PENDING };
  }
  return cardStatus;
};

export const WalletsTypes = {
  FIAT: 'fiat',
  CRYPTO: 'crypto',
  INTERNAL: 'internal',
  STABLE: 'stable',
};

export const CardPaymentMethods = {
  FIAT: 'fiat',
  CRYPTO_OR_STABLE: 'crypto_or_stable',
  PGW: 'pgw',
};

export const MoreCollateralPaymentMethod = {
  PGW: 'pgw',
  LEDGER: 'ledger',
};

export const CardVisaTransactionTypes = {
  OUTGOING: 0,
  REFUND: 1,
  TRANSFER: 2,
  WITHDRAWAL: 3,
  SERVICEFEE: 4,
  PENDING: 5,
};

export const CardMastercardTransactionTypes = {
  SETTLED: '00',
  DECLINED: '05',
};

export const CardMastercardTransactionResponseCodes = {
  APPROVED: '00',
  DECLINED: '07',
  DO_NOT_HONOR: '05',
};

export const CardMastercardTransactionStatuses = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  DECLINED: 'declined',
};

export const CardMastercardTransactionSign = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
};

export const DatePeriods = {
  YEAR: 'year',
  LAST_WEEK: 'last_week',
  LAST_MONTH: 'last_month',
  HALF_YEAR: 'half_year',
};

export const KeyCode = {
  BACKSPACE: 8,
  DELETE: 46,
  ZERO: 48,
  NINE: 57,
  NUMLOCK_ZERO: 96,
  NUMLOCK_NINE: 105,
  SPACE: 32,
};

export const PrivacyPolicySettingsUrls = {
  CARD_MONAVATE_PRIVACY_POLICY_CONTENT_URL: 'content_url_monavate_privacy_policy',
  CARD_GALILEO_PRIVACY_POLICY_CONTENT_URL: 'content_url_card_privacy_policy',
};

export const TermsSettingsUrls = {
  CARD_CONNECT_FINANCIAL_ROW_TERMS_CONTENT_URL: 'content_url_connect_financial_row_terms',
  CARD_MONAVATE_TERMS_CONTENT_URL: 'content_url_monavate_terms',
  CARD_GALILEO_TERMS_CONTENT_URL: 'cardholder_term_galileo_us_user',
  CARD_TERMS_CONTENT_URL: 'content_url_card_user_terms',
};

export const ConfirmCardTransactionScreensFlow = {
  CONFIRM_TRANSACTION: 'confirm_transaction',
  VERIFY_TRANSACTION: 'verify_transaction',
};

export const ReportCardScreensFlow = {
  REPORT_CARD_ISSUE_OPTIONS: 'report_card_issue_options',
  REPORT_CARD_CONFIRM: 'report_card_confirm',
  ORDER_REPLACEMENT_CARD: 'order_replacement_card',
  NEW_CARD_ORDER: 'new_card_order',
  NEW_MONAVATE_CARD_ORDER: 'new_monavate_card_order',
  CONFIRM_DETAILS: 'confirm_details',
  CONFIRM_DELIVERY_TYPE: 'confirm_delivery_type',
  CONFIRM_EXPEDITED_AMOUNT: 'confirm_expedited_amount',
  EDIT_MAILING_ADDRESS: 'edit_mailing_address',
  LAST_FIVE_TRANSACTIONS: 'last_five_transactions',
  NOT_RECOGNIZED_TX: 'not_recognized_tx',
  ERROR_TX: 'error_tx',
};

export const LoyaltyProgramScreensFlow = {
  SELECT_CURRENCY: 'select_currency',
};

export const UK_COUNTRY = 'United Kingdom';

export const cardOrderFeesKeys = {
  UK: 'card-order-fee-uk',
  EU: 'card-order-fee-eu',
  US: 'card-order-fee-us',
  ROW: 'card-order-fee-virtual',
};

export const LEDGER_ENTRY_SOURCE_FUND = {
  ALL: '',
  CRYPTO: 'CRYPTO',
  CRYPTODRAFT: 'CRYPTODRAFT',
  PAID_IN: 'PAID_IN',
};

export const BUFFER_AUTHORIZATION_TYPES = {
  AUTH_REVERSAL: 'AUTH_REVERSAL',
  REFUND_REVERSAL: 'REFUND_REVERSAL',
  REFUND_CLEARING: 'REFUND_CLEARING',
  REFUND_PARTIAL_REVERSAL: 'REFUND_PARTIAL_REVERSAL',
  REFUND_TRANSACTION: 'REFUND_TRANSACTION',
  AUTH_REFUND_REVERSAL: 'AUTH_REFUND_REVERSAL',
  AUTH_REFUND: 'AUTH_REFUND',
  POSITIVE_ADVICE_CREDIT: 'POSITIVE_ADVICE_CREDIT',
  POSITIVE_ADVICE_DEBIT: 'POSITIVE_ADVICE_DEBIT',
  AUTH_CREDIT: 'AUTH_CREDIT',
  AUTH_DEBIT: 'AUTH_DEBIT',
  AUTH_PARTIAL_REVERSAL: 'AUTH_PARTIAL_REVERSAL',
};

export const BUFFER_AUTHORIZATION_TYPES_MAP = {
  AUTH_REFUND: 'Refund',
  REFUND_TRANSACTION: 'Refund',
  REFUND_PARTIAL_REVERSAL: 'Refund',
  REFUND_REVERSAL: 'Refund',
  REFUND_CLEARING: 'Refund',
  POSITIVE_ADVICE_CREDIT: 'Credit',
  POSITIVE_ADVICE_DEBIT: 'Authorization',
  AUTH_CREDIT: 'Credit',
  AUTH_DEBIT: 'Authorization',
  AUTH_PARTIAL_REVERSAL: 'Authorization',
};

export const SETTLMENT_INTREST_PAYMENT_AVAILABLE_CURRENCIES = [
  'BTC',
  'ETH',
  'USDT',
  'USDC',
  'EURT',
];

export const MONAVATE_MAX_EMBOSSED_NAME_LENGTH = 21;

export const CARD_NETWORKS = {
  VISA: 'VISA',
  MASTERCARD: 'MASTERCARD',
  AMERICAN_EXPRESS: 'American Express',
  DISCOVER: 'Discover',
  UNION_PAY: 'UnionPay',
  JCB: 'JCB',
};

const capitalize = (value) => `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;

export const resolveCardNetwork = (cardProvider, cardStatus) => {
  if (!getCardCapabilities(cardProvider).networkFromStatus) {
    return capitalize(CARD_NETWORKS.MASTERCARD);
  }
  const network = cardStatus?.network;
  if (!network) {
    return capitalize(CARD_NETWORKS.VISA);
  }
  return capitalize(CARD_NETWORKS[network.toUpperCase()] ?? network);
};

export const resolveCardFiatCurrency = (cardProvider, cardStatus, cardInfo) => {
  if (cardProvider === cardProviders.MONAVATE && cardStatus?.cardCurrency) {
    return cardStatus.cardCurrency.toUpperCase();
  }
  if (cardInfo?.platform) {
    return cardInfo.platform.toUpperCase();
  }
  if (getCardCapabilities(cardProvider).currencyFromStatus) {
    return cardStatus?.currency?.toUpperCase() || 'USD';
  }
  return 'EUR';
};

export const shouldShowActivateAlert = (cardProvider, cardStatus, userRegionSettings) =>
  Boolean(
    cardStatus &&
      cardStatus.isActivatable &&
      cardStatus.cardState?.toUpperCase() !== CardState.ACTIVE &&
      !Object.values(cardProviders).includes(cardProvider) &&
      userRegionSettings?.default_card_type?.toLowerCase() !== mainCardTypes.VIRTUAL
  );
